<nz-switch [(ngModel)]="isDarkTheme"
           [nzControl]="true"
           (click)="switchTheme()"
           [nzCheckedChildren]="'theme.dark' | translate"
           [nzUnCheckedChildren]="'theme.light' | translate"></nz-switch>
